export default {
'ar': $localize`Arabic`,
'hy': $localize`Armenian`,
'bs': $localize`Bosnian`,
'bg': $localize`Bulgarian`,
'hr': $localize`Croatian`,
'da': $localize`Danish`,
'nl': $localize`Dutch`,
'en': $localize`English`,
'et': $localize`Estonian`,
'es': $localize`Spanish`,
'tl': $localize`Filipino`,
'fi': $localize`Finnish`,
'fr': $localize`French`,
'ka': $localize`Georgian`,
'de': $localize`German`,
'el': $localize`Greek`,
'hu': $localize`Hungarian`,
'id': $localize`Indonesian`,
'it': $localize`Italian`,
'lv': $localize`Latvian`,
'lt': $localize`Lithuanian`,
'mk': $localize`Macedonian`,
'mt': $localize`Maltese`,
'no': $localize`Norwegian`,
'pl': $localize`Polish`,
'pt': $localize`Portuguese`,
'ro': $localize`Romanian`,
'ru': $localize`Russian`,
'sr': $localize`Serbian`,
'sk': $localize`Slovak`,
'sl': $localize`Slovenian`,
'sw': $localize`Swahili`,
'sv': $localize`Swedish`,
'th': $localize`Thai`,
'tr': $localize`Turkish`,
'vi': $localize`Vietnamese`,
'cs': $localize`Czech`,
'ga': $localize`Irish`, 
'lb': $localize`Luxembourgish`,
}
